import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Clock, Check, X } from "lucide-react";
import { useAuth } from "../../AuthContext";
import { BACKEND_URL } from "../../lib/backend";
import { fmtRange } from "../../lib/events";

const STATUS = {
  pending: { label: "In review", Icon: Clock, cls: "bg-amber-500/12 text-amber-600" },
  published: { label: "Published", Icon: Check, cls: "bg-emerald-500/12 text-emerald-600" },
  rejected: { label: "Not accepted", Icon: X, cls: "bg-rose-500/12 text-rose-500" },
};

/** The member's own proposals with their editorial status. */
export function MyProposals({ c, refreshKey }) {
  const { authHeader } = useAuth();
  const [data, setData] = useState(null);
  useEffect(() => {
    axios.get(`${BACKEND_URL}/api/events/proposals/mine`, { headers: authHeader() }).then(({ data }) => setData(data)).catch(() => setData({ items: [] }));
  }, [refreshKey]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!data?.items?.length) return null;
  return (
    <div className="mt-6" data-testid="my-proposals">
      <p className={`category-tag text-[10px] mb-2 ${c.muted}`}>YOUR PROPOSALS · {data.today}/{data.daily_limit} TODAY</p>
      <ul className="space-y-1.5">
        {data.items.map((p) => {
          const s = STATUS[p.status] || STATUS.pending;
          return (
            <li key={p.id} data-testid={`my-proposal-${p.id}`} className={`flex flex-wrap items-center gap-2 text-sm rounded-lg px-3 py-2 ${c.soft}`}>
              <span className={`px-1.5 py-0.5 rounded-full text-[10px] category-tag inline-flex items-center gap-1 ${s.cls}`} data-testid={`my-proposal-status-${p.id}`}><s.Icon className="w-2.5 h-2.5" />{s.label}</span>
              <span className={`font-medium ${c.text}`}>{p.fields?.name}</span>
              <span className={`text-xs ${c.muted}`}>{fmtRange(p.fields?.start_date, p.fields?.end_date)}{p.fields?.city ? ` · ${p.fields.city}` : ""}</span>
              {p.web_url && <Link to={p.web_url} className={`text-xs underline ${c.accent}`} data-testid={`my-proposal-link-${p.id}`}>Open the event page →</Link>}
              {p.status === "rejected" && <span className={`text-xs ${c.muted}`} data-testid={`my-proposal-reason-${p.id}`}>Reason: {p.reject_reason_label}{p.reject_note ? ` — ${p.reject_note}` : ""}</span>}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
